module.exports = __webpack_public_path__ + "img/Cancer.d7dae51d.png";